import { render, staticRenderFns } from "./secondarymenu.vue?vue&type=template&id=6be9ce7a&scoped=true&"
import script from "./secondarymenu.vue?vue&type=script&lang=js&"
export * from "./secondarymenu.vue?vue&type=script&lang=js&"
import style0 from "./secondarymenu.vue?vue&type=style&index=0&id=6be9ce7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9ce7a",
  null
  
)

export default component.exports